import IconCityHouse from '@/components/icons/IconCityHouse';
import IconBuildings from '../../components/icons/IconBuildings';
import IconCrown from '../../components/icons/IconCrown';
import IconFire from '../../components/icons/IconFire';
import IconHelmet from '../../components/icons/IconHelmet';
import IconRocket from '../../components/icons/IconRocket';
import { achievementLevel } from './config';

const jobAchievements = [
  {
    name: 'First Day on the Job',
    description: 'Complete your first Shitty Job',
    category: 'Jobs',
    level: achievementLevel.bronze,
    icon: <IconCityHouse />,
    requirements: {
      jobs: 1,
    },
  },
  {
    name: 'Hard Worker',
    description: 'Complete 10 Shitty Jobs',
    category: 'Jobs',
    level: achievementLevel.silver,
    icon: <IconHelmet />,
    requirements: {
      jobs: 10,
    },
  },
  {
    name: 'Job Master',
    description: 'Complete 50 Shitty Jobs',
    category: 'Jobs',
    level: achievementLevel.gold,
    icon: <IconRocket />,
    requirements: {
      jobs: 50,
    },
  },
  {
    name: 'Job Legend',
    description: 'Complete 200 Shitty Jobs',
    category: 'Jobs',
    level: achievementLevel.platinum,
    icon: <IconFire />,
    requirements: {
      jobs: 200,
    },
  },
  {
    name: 'Job King',
    description: 'Complete 500 Shitty Jobs',
    category: 'Jobs',
    level: achievementLevel.diamond,
    icon: <IconCrown />,
    requirements: {
      jobs: 500,
    },
  },
];

export default jobAchievements;
